import { CanMatchFn } from '@angular/router';
import { AuthStorageService } from '@core/services/auth-storage.service';
import { inject } from '@angular/core';
import { isTokenExpired } from '@shared/helpers/is-token-expired';
import { PostLoginRedirectService } from '@core/services/post-login-redirect.service';

export const authMatchGuard: CanMatchFn = () => {
  const auth = inject(AuthStorageService);
  const postLoginRedirectService = inject(PostLoginRedirectService);

  const authData = auth.getAuthData();

  if (!authData || isTokenExpired(new Date(authData.expiresAt))) {
    auth.clearAuthData();
    if (postLoginRedirectService.shouldKeepInitialUrl()) {
      return postLoginRedirectService.createLoginUrlTree(
        postLoginRedirectService.getCurrentBrowserUrl()
      );
    }

    return postLoginRedirectService.createLoginUrlTree();
  }

  return true;
};
